export default __webpack_public_path__ + "static/media/darkcarz_black_logo.6027e784.png";